import { AvailableSubscription } from '@types';
import apiClient from './apiClient';
import { Adyen } from '@quickmd-llc/design-system';
import { PatientSubscription } from '@qmd-types/patient';
import { getTimeZone } from '@utils';

export const fetchSubscriptionsAvailableToPatient = async () => {
  const { data } = await apiClient.get<AvailableSubscription[]>(
    'api/v1/subscriptions',
  );

  return data;
};

type AddSubscriptionInput = {
  subscription: string;
  adyenIsEnabled: boolean;
  creditCardId: string;
};

export const addSubscription = async ({
  subscription,
  adyenIsEnabled,
  creditCardId,
}: AddSubscriptionInput) => {
  const { data } = await apiClient.post<{ ErrorCode: null | string }>(
    `api/v1/subscriptions/${subscription}/subscribe${Adyen.getAdyenQueryString(adyenIsEnabled)}`,
    { creditCardId, timeZone: getTimeZone() },
  );

  return data;
};

export const fetchPatientSubscriptions = async () => {
  const { data } = await apiClient.get<PatientSubscription[]>(
    'api/v1/subscriptions/subscribed',
  );

  return data;
};
